import * as S from "./ChatDataList.styles";
import cx from "classnames";
import React, { memo, useCallback, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { IMAGE_TYPES, VIDEO_TYPES, MESSAGE_STATUS, MESSAGES_ITEM_COUNT } from "configs/constants";
import { scrollMessages } from "socket/socket";
import { SeenMessageIcons } from 'components';
import { addHistory } from "redux_toolkit/reducers/chat/chatSlice";
import { messageWithURL } from "utils/functions";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';


export const ChatDataList = memo(({
  messagesChat=[],
  chatId,
  chatCompanionId,
  chatLogUsers,
  agentName
}) => {
  const dispatch = useDispatch();
  const { _id: userPartnerId } = useSelector(({ userPartner }) => userPartner.userData);
  const lastItemMessages = messagesChat.length? messagesChat[messagesChat.length-1][0] : 0;
      const chat = useSelector(({ chats }) => chats.list[chatId]);
  const [length, setLength] = useState(messagesChat?.length);
  const oldScrollRef = useRef(0);
  const lastMsgIndexRef = useRef(lastItemMessages);
  const areaRef = useRef(null);
    const {list: visitors} = useSelector(({ visitors }) => visitors);
    const visitor = visitors.find((visitor) => visitor._id === chatCompanionId);

    const [banned, setBanned] = useState(false);


  useEffect(() => {
    if(visitor){
      setBanned( (visitor.banExpire && moment().isBefore(visitor.banExpire)) || false );
    }
  }, [visitor]);

  const isAtBottom = useRef(true);
  const [newMessageCount, setNewMessageCount] = useState(0);

  useEffect(() => {
    if(!areaRef.current) return;
    switch (true) {
      case messagesChat?.length === length:
        setLength(messagesChat?.length);
        if(isAtBottom.current) areaRef.current.scrollTo(0, areaRef.current.scrollHeight);
        break;
      case lastMsgIndexRef.current !== lastItemMessages:
        if(isAtBottom.current) {
          areaRef.current.scrollTo(0, areaRef.current.scrollHeight);
        } else {
          setNewMessageCount(prev => prev + 1);
        }
        lastMsgIndexRef.current = lastItemMessages;
        break;
      default:
        areaRef.current.scrollTop = areaRef.current.scrollHeight - areaRef.current.clientHeight - oldScrollRef.current;
        break;
    }
  }, [messagesChat?.length, length, lastItemMessages]);

  const isUserMessage = useCallback((senderId) => {
    return chatCompanionId !== senderId;
  }, [chatCompanionId]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.currentTarget;
    isAtBottom.current = scrollHeight - scrollTop - clientHeight < 50;
    if(isAtBottom.current) setNewMessageCount(0);
    if (scrollTop === 0) {
      if(!messagesChat[0]) return;
      oldScrollRef.current = areaRef.current.scrollHeight - areaRef.current.clientHeight;
      scrollMessages(
        chatId,
        messagesChat[0],
        (data) => {
          dispatch(addHistory({chatId, messages: data}));
        }
      )
    }
  };

  const checkFileType = (filePath)=> {
    const fileSplit = filePath.split('.');
    const fileType = fileSplit[fileSplit.length-1];

    let type = '';
    if(IMAGE_TYPES.includes(fileType)) type = 'image';
    if(VIDEO_TYPES.includes(fileType)) type = 'video';
    return type;
  }

  const test = () => {
    if(areaRef && areaRef.current && areaRef.current.lastChild){
      const lastMessage = areaRef.current.lastChild.getBoundingClientRect();
      const messages = areaRef.current.getBoundingClientRect();

      if(lastMessage.y < messages.y + messages.height){
        areaRef.current.scrollTo(0, 1000000000);
      }
    }
  }

  return (
      <>
    <div style={{position: 'relative'}}>
    <S.ChatHistoryContainer
      className="ChatDataListStyle"
      ref={areaRef}
      onScroll={handleScroll}
    >
      {messagesChat?.map((message, index) => {
        if(!message || !Array.isArray(message) || message.length < MESSAGES_ITEM_COUNT) return null;
        const thisUserId = message[1];
        const text = message[2] == null ? '' : String(message[2]);
        const file = typeof message[3] === 'string' ? message[3] : '';
        const date = message[4];
        const statusMsg = message[5];
        const isBot = !thisUserId;
        const parsedDate = new Date(date);
        const createDate = Number.isNaN(parsedDate.getTime()) ? Date.now() : parsedDate.getTime();
        const yourMessage = userPartnerId === thisUserId;

        return (
          <S.MessageItem
            key={message[0] || index}
            className={cx({
              myMessage: isUserMessage(thisUserId),
              file: !!file,
              botMessage: !thisUserId 
            })}
          >
            {
              !isBot? <>
                <S.MessageInfo>
                  {
                      <S.SenderName>
                        {yourMessage? 'You' : (chatLogUsers[thisUserId] || agentName)}
                      </S.SenderName>
                  }

                </S.MessageInfo>
                <div>{messageWithURL(text)}</div>
                {
                  file.length ?
                  <a className='file-content' href={file} target="_blank" rel="noreferrer">
                    {checkFileType(file) === 'image' && <S.FileImage alt={file} src={file} />}
                    {checkFileType(file) === 'video' && <video autoPlay controls src={file} />}
                  </a>:''
                }
                <div style={{display: 'flex', fontSize: '10px', justifyContent: isUserMessage(thisUserId) ? 'end': 'start', gap: '5px'}}>
                  {moment(createDate).local().format('HH:mm:ss') + ' '}
                  {

                    // Message seen or not
                    !agentName && yourMessage && statusMsg !== MESSAGE_STATUS.UNDELIVERED &&
                    <SeenMessageIcons seen={statusMsg===MESSAGE_STATUS.READ} />
                  }
                </div>
              </>:<S.BotContainer>
                <div className='message-content'>
                  {chatLogUsers[text.split('_')[0]]} { moment(createDate).local().format('DD-MM-YYYY HH:mm') }
                </div>
                <span>{text.split('_')[1]}</span>
              </S.BotContainer>
            }
          </S.MessageItem>
        );
      }

      )}
      {banned && visitor &&<div style={{
        fontSize: '14px',
        color: 'rgb(85, 85, 85)',
        fontWeight: 600,
        textAlign: 'center',
        fontStyle: 'italic'
      }}> {visitor.name} is banned {moment(visitor.updatedAt).local().format('DD-MM-YYYY HH:mm')}</div>}
      {chat && chat.typing && <S.MessageItem
          key={Math.random()}
          className={cx({
            myMessage: false,
            file: false,
            typingMessage: true
          })}
      >
        <span className="typing"> </span>
      </S.MessageItem>}
    </S.ChatHistoryContainer>
    {newMessageCount > 0 && (
      <S.NewMessageIndicator onClick={() => {
        areaRef.current.scrollTo(0, areaRef.current.scrollHeight);
        setNewMessageCount(0);
      }}>
        <S.NewMessageCount>{newMessageCount}</S.NewMessageCount>
        <S.NewMessageButton><KeyboardArrowDownIcon /></S.NewMessageButton>
      </S.NewMessageIndicator>
    )}
    </div>
        {chat && chat.typing && setTimeout(test, 10) && <></>}
        </>
  );
},(prevProps, nextProps)=> {
    // check latest message status
    const msgPrevLatestItem = prevProps.messagesChat[prevProps.messagesChat.length-1];
    const msgNextLatestItem = nextProps.messagesChat[nextProps.messagesChat.length-1];
    let checkMessageStatus = true;
    if(prevProps.messagesChat.length && msgPrevLatestItem && msgNextLatestItem) {
      checkMessageStatus = msgPrevLatestItem[msgPrevLatestItem?.length-1] === msgNextLatestItem[msgNextLatestItem?.length-1];
    }

    return(
      checkMessageStatus &&
      prevProps.messagesChat.length === nextProps.messagesChat.length &&
      prevProps.chatId === nextProps.chatId &&
      prevProps.chatCompanionId === nextProps.chatCompanionId &&
      prevProps.chatLogUsers === nextProps.chatLogUsers &&
      prevProps.agentName === nextProps.agentName
    );
  }
);
